import { FC } from 'react';
import { CircularProgress } from '@mui/material';
import cn from 'classnames';

import { ILoaderProps } from './Loader.interface';

import './styles.scss';

export const Loader: FC<ILoaderProps> = ({ className, size = 50 }) => (
  <div className={cn('loader', className)}>
    <CircularProgress color="primary" size={size} />
  </div>
);

export default Loader;
